import { Banner } from 'component/Banner/Banner'
import { Button } from 'component/Button'
import { Scroll } from 'component/Scroll'
import { Gap, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useSizes } from 'feature/sizes/useSizes'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { BuyCard } from 'page/InferenceScreen/buy/BuyCard'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { formatSize } from 'type/size'

export const BuyBanner = observer(() => {
  const inference = store.inferences.buy!
  const { items } = inference
  const count = items.length
  const sizes = useSizes(inference)

  const onCancel = useLatestCallback(() => {
    controller.closeBuyBanner()
  })

  const onNew = useLatestCallback(() => {
    controller.createNewOutfit(inference)
  })

  const title = opt.buy_title
  const combo_only = opt.options.window?.try_on_combo_only
  const bottom = combo_only ? undefined : (
    <Button wide large onClick={onNew}>
      {i18n('CreateNewOutfit')}
    </Button>
  )

  return (
    <Banner title={title} onCancel={onCancel} bottom={bottom}>
      <Vertical>
        <Typo secondary center>
          {i18n('ItemsCount', { count })}
        </Typo>
        <Gap height={12} />
        <Scroll>
          <Space wide>
            <Gap spring />
            <Space gap={16} maxWidth="100%" top parallel>
              {items.map((item, i) => (
                <BuyCard key={i} item={item} />
              ))}
            </Space>
            <Gap spring />
          </Space>
          {!!sizes.length && <Vertical gap={4} wide center>
            <Gap height={12} />
            <Typo secondary size={12}>
              {i18n('RecommendedSizes')}
            </Typo>
            <Space gap={12} wide columns>
              {sizes.map((size, index) => {
                return <Typo key={index} size={11} center secondary>
                  {formatSize(size, { divider: ' - ' })}
                </Typo>
              })}
            </Space>
          </Vertical>}
        </Scroll>
      </Vertical>
    </Banner>
  )
})
